import { RevenueDeepDiveActivity } from 'activities/company/RevenueDeepDiveActivity/RevenueDeepDiveActivity';
import {
  Navigate,
  Outlet,
  RouteObject
} from 'react-router-dom';
import { CompaniesActivity } from './CompaniesActivity/CompaniesActivity';
import { CompanyDetailActivity } from './CompanyDetailActivity/CompanyDetailActivity';
import { EarningsCallSummaryActivity } from './EarningsCallSummaryActivity/EarningsCallSummaryActivity';
import { StockAnalysisActivity } from './StockAnalysisActivity/StockAnalysisActivity';



export const routes: RouteObject[] = [{
  path: '',
  element: <CompaniesActivity />,
  children: [{
    path: ':companyId',
    element: <Outlet />,
    children: [
      {
        path: '',
        index: true,
        element: <Navigate to='detail' />
      },
      {
        path: 'detail',
        element: <CompanyDetailActivity />
      },
      {
        path: 'revenueDeepDive',
        element: <RevenueDeepDiveActivity />
      },
      {
        path: 'earningsCall',
        element: <EarningsCallSummaryActivity />
      },
      {
        path: 'investmentCase',
        element: <StockAnalysisActivity />
      }
    ]
  }]
}];
